/**
 * Bank Connection Configuration (FSD Part 3, TRS-S02). The wiring packet spreads
 * `TREASURY_BANK_CONNECTION_ROUTES` into the router beside `TREASURY_ROUTES` and
 * adds the `treasury-bank-connections` nav item.
 *
 * One screen: the register with its health strip, and create/edit, test, fetch,
 * activate and disable as dialogs on it. Gated on `treasury.connection.read`,
 * which is what `GET /bank-connections` and `GET /bank-connections/health`
 * declare; each action is further gated on its own route's permission.
 */

import type { RouteRecordRaw } from 'vue-router'

import { BANK_CONNECTION_PERMISSIONS } from '@/modules/treasury/bank-connections/permissions'

export const TREASURY_BANK_CONNECTIONS_PATH = '/treasury/bank-connections'

export const TREASURY_BANK_CONNECTION_ROUTES: RouteRecordRaw[] = [
  {
    path: TREASURY_BANK_CONNECTIONS_PATH,
    name: 'treasury-bank-connections',
    component: () => import('@/modules/treasury/bank-connections/BankConnectionsView.vue'),
    meta: {
      titleKey: 'treasury.routeTitles.bankConnections',
      permission: BANK_CONNECTION_PERMISSIONS.read,
    },
  },
]
